import classic from 'ember-classic-decorator';
import BaseValidator from 'ember-cp-validations/validators/base';

import { countThreadsTopics } from 'later/utils/extract-threads-topic';

@classic
class ThreadsMultipleTopics extends BaseValidator {
  validate() {
    if (!this.model.get('socialProfile.isThreads')) {
      return true;
    }
    const topicCount = countThreadsTopics(this.model.caption);
    if (topicCount > 1) {
      return this.createErrorMessage('threads_multiple_topics');
    }
    return true;
  }
}

export default ThreadsMultipleTopics;
